(function () {
  var config = document.getElementById('ibe-birthday-confetti');
  if (!config) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Fires once per browser session, whichever page the visitor lands on first.
  var sessionKey = config.getAttribute('data-session-key');
  try {
    if (sessionStorage.getItem(sessionKey)) return;
    sessionStorage.setItem(sessionKey, '1');
  } catch (error) {
    // Private browsing blocks sessionStorage; fall through and celebrate anyway.
  }

  var colors = (config.getAttribute('data-colors') || '')
    .split(',')
    .map(function (color) {
      return color.trim();
    })
    .filter(function (color) {
      return color !== '' && color !== 'rgba(0,0,0,0)';
    });

  var particleCount = parseInt(config.getAttribute('data-particle-count'), 10) || 260;

  function celebrate() {
    var canvas = document.createElement('canvas');
    canvas.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999';
    document.body.appendChild(canvas);

    // useWorker: false keeps the particles on a regular canvas. The worker
    // renderer draws to an OffscreenCanvas, which screenshot-based QA tools
    // cannot capture.
    var fire = window.confetti.create(canvas, { resize: true, useWorker: false });

    var shared = {
      colors: colors.length ? colors : undefined,
      disableForReducedMotion: true,
    };

    function burst(overrides) {
      var options = { particleCount: particleCount, spread: 100, startVelocity: 55, scalar: 1.2, ticks: 260 };
      for (var key in shared) options[key] = shared[key];
      for (var override in overrides) options[override] = overrides[override];
      return fire(options);
    }

    function sides(count) {
      burst({ particleCount: count, angle: 60, spread: 80, origin: { x: 0, y: 0.9 } });
      return burst({ particleCount: count, angle: 120, spread: 80, origin: { x: 1, y: 0.9 } });
    }

    var sideCount = Math.round(particleCount * 0.7);

    burst({ origin: { x: 0.5, y: 0.75 } });
    sides(sideCount);

    setTimeout(function () {
      burst({ particleCount: Math.round(particleCount * 0.8), origin: { x: 0.3, y: 0.8 } });
      burst({ particleCount: Math.round(particleCount * 0.8), origin: { x: 0.7, y: 0.8 } });
    }, 400);

    setTimeout(function () {
      sides(sideCount).then(function () {
        canvas.remove();
      });
    }, 900);
  }

  function load() {
    if (window.confetti) {
      celebrate();
      return;
    }

    var script = document.createElement('script');
    script.src = config.getAttribute('data-library-url');
    script.onload = celebrate;
    document.head.appendChild(script);
  }

  if (document.readyState === 'complete') {
    load();
  } else {
    window.addEventListener('load', load);
  }
})();
